import { render, staticRenderFns } from "./AboutUnidade.vue?vue&type=template&id=7ac70320&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./AboutUnidade.vue?vue&type=style&index=0&id=7ac70320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac70320",
  null
  
)

export default component.exports